import { render, staticRenderFns } from "./untieband.vue?vue&type=template&id=b3ba1950&scoped=true"
import script from "./untieband.vue?vue&type=script&lang=js"
export * from "./untieband.vue?vue&type=script&lang=js"
import style0 from "./untieband.vue?vue&type=style&index=0&id=b3ba1950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ba1950",
  null
  
)

export default component.exports